import { Typography } from '@mui/material';
import { IDashboardTemplateItem } from 'pages/Dashboards/interfaces';
import {
  DashboardTemplateItemCnt,
  TemplateImage,
  StyledItem,
} from 'pages/Dashboards/DashboardTemplates/dashboardTemplateItem/templateItem.style';
import { dashboardImages } from 'pages/Dashboards/DashboardTemplates/dashboardTemplateItem/constants';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';

interface IDashboardTemplateItemProps {
  item: IDashboardTemplateItem;
  index: number;
}
function DashboardTemplateItem(props: IDashboardTemplateItemProps) {
  const { item, index } = props;
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();
  const handleReportClick = (e, report) => {
    navigateWithWorkspaceUrl(`/dashboards/template/${report.id}`);
  };
  return (
    <DashboardTemplateItemCnt
      item
      xs={12}
      sm={6}
      md={3}
      onClick={(e) => handleReportClick(e, item)}
    >
      <StyledItem>
        <div className={'imageCnt'}>
          <TemplateImage
            src={dashboardImages[index]}
            alt={`Image ${item.id}`}
          />
        </div>
        <div className={'contentCnt'}>
          <Typography variant="h6" component="div" className={'heading'}>
            {item?.name}
          </Typography>
          <Typography
            variant="subtitle1"
            component="div"
            className={'subTitle'}
          >
            {item.description}
          </Typography>
        </div>
      </StyledItem>
    </DashboardTemplateItemCnt>
  );
}

export default DashboardTemplateItem;
